export default __webpack_public_path__ + "static/22-e84744689a06fda20de92655befc9f16.webp";